import { Dropdown } from "primereact/dropdown";
import styled from "styled-components";
import { colors } from "../../../../../../../theme/theme";

export const ActionButton = styled(Dropdown)`
	border-radius: 50%;
	border-color: transparent;
	background: transparent;

	&:not(.p-disabled):hover {
		border-color: transparent;
		background: ${colors.greyscale.light_grey};
	}

	.p-dropdown-label {
		display: none;
	}

	.p-dropdown-trigger {
		height: 36px;
		width: 36px;
		border-radius: 18px;
	}

	.p-dropdown-trigger-icon {
		position: relative;
		height: 100%;
		width: 100%;
		display: flex;
		justify-content: center;
	}

	& .p-dropdown-trigger-icon::before {
		content: url('data:image/svg+xml,<svg stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"></path></svg>');
		color: ${colors.greyscale.darker_grey};
		position: absolute;
		top: 50%;
		transform: translateY(calc(-50% + 2px));
	}
`;
